export default __webpack_public_path__ + "static/agent-home-real-0ef33d593ed7e220706097ab05d5f678.png";